
import RequestAbstract from "../abstract";

export default class CryptoWithdrawals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/crypto/withdrawals";
    }
}

